import { useMemo, useState } from "react";
import { useTable } from "react-table";
import { defaultDateDisplay, formatCurrency } from "../../../helpers";
import primaryComponents from "../../primaryComponents";
import secondaryComponents from "..";
import usePendingCheckoutSession from "../../../hooks/usePendingCheckoutSession";
import { useParams } from "react-router-dom";
import { useGetInfo } from "../../../hooks/useGetInfo";

const usePendingCheckout = () => {
  const { store_id } = useParams();
  const { getStoreInfo } = useGetInfo();
  const storeDetails = getStoreInfo(store_id);
  const [showCancelPrompt, setShowCancelPrompt] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});

  const {
    isFetchingSessions,
    pendingSessions,
    metaDetails,
    search,
    cancelCheckout,
    continueCheckout,
    filterBySearch,
    gotoPage,
    filterByKey,
  } = usePendingCheckoutSession({ isEnabled: true });

  const statusMap = {
    PENDING_CHECKOUT: "Pending Checkout",
    PAYMENT_REQUIRED: "Awaiting Payment",
  };
  const statusColor = {
    PENDING_CHECKOUT: "chilled--text",
    PAYMENT_REQUIRED: "pending--squared",
  };

  const columns = useMemo(
    () => [
      {
        Header: "Order Date/Time",
        accessor: "created_at",
        Cell: ({ cell: { value } }) => (
          <span>{value ? defaultDateDisplay(value) : "N/A"}</span>
        ),
      },
      {
        Header: "Customer",
        accessor: "customer",
        Cell: ({ cell: { value } }) => (value ? value?.first_name : "N/A"),
      },
      {
        Header: "Cashier",
        accessor: "user",
        Cell: ({ cell: { value } }) => (value ? value?.first_name : "N/A"),
      },
      {
        Header: "Items",
        accessor: "items",
        Cell: ({ cell: { value } }) => (
          <secondaryComponents.ConcatenateWithTooltip
            value={value}
            noOfCharacters={50}
          />
        ),
      },
      {
        Header: "Amount",
        accessor: "total_amount",
        Cell: ({ cell: { value } }) => (
          <span>
            {formatCurrency({
              value: value,
              currencyCode: storeDetails?.currency_code,
            })}
          </span>
        ),
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ cell: { value } }) => (
          <span className={`${statusColor[value]}`}>
            {value ? statusMap[value] : null}
          </span>
        ),
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: ({ row }) => {
          return (
            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <primaryComponents.Button
                classNames="btn btn--primary smallBtn"
                onClick={() =>
                  continueCheckout(row?.original?.id, row?.original?.customer)
                }
              >
                Checkout
              </primaryComponents.Button>
              <primaryComponents.Button
                classNames="btn btn--outline smallBtn"
                onClick={() => {
                  setSelectedItem(row?.original);
                  setShowCancelPrompt(true);
                }}
              >
                Cancel
              </primaryComponents.Button>
            </span>
          );
        },
      },
    ],
    [],
  );
  const instance = useTable({ columns, data: pendingSessions || [] });

  return {
    selectedItem,
    instance,
    isFetchingSessions,
    pendingSessions,
    metaDetails,
    showCancelPrompt,
    search,
    filterBySearch,
    cancelCheckout,
    filterByKey,
    gotoPage,
    setShowCancelPrompt,
  };
};

export default usePendingCheckout;
